export default {
  confirm_disconnect: 'Êtes-vous sûr de vouloir vous déconnecter ?'
}
